import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {FaMobileAlt, FaKey} from 'react-icons/fa';
import Post from './components/Post'; // your API handler
import betx from './images/betx.png';
import splash3 from './images/splash3.jpg';

const PostFree = () => {
  const navigate = useNavigate();

  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [passwordShow, setPasswordShow] = useState(true);

  // 🔑 LOGIN FUNCTION
  const login = async () => {
    if (!mobile) {
      alert('Enter mobile number');
    } else if (!password) {
      alert('Enter password');
    } else {
      try {
        console.log('Loading... Please Wait');

        const res = await Post.Login({mobile, password});

        console.log('Login Response:', res);

        if (res.error) {
          alert(res.errorMsg);
        } else {
          // ✅ Save user + token
          localStorage.setItem('user', JSON.stringify(res.data));
          localStorage.setItem('token', res.token);

          navigate('/home');
        }
      } catch (err) {
        console.error('Login failed:', err);
        alert('Something went wrong, please try again.');
      }
    }
  };

  return (
    <>
      <style>{`
        .custominput::placeholder {
          color: white;
        }
      `}</style>

      <div style={{backgroundColor: '#E6DBBA', minHeight: '100vh'}}>
        <div style={{...styles.bg, backgroundImage: `url(${splash3})`}}>
          <div style={styles.layer}>
            {/* Logo */}
            <div
              style={{
                marginTop: 60,
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 20,
                overflow: 'hidden',
              }}>
              <img src={betx} alt="logo" style={{height: 200, width: 250}} />
            </div>

            {/* Card */}
            <div style={styles.card}>
              {/* Mobile Number */}
              <div style={styles.inputWrapper}>
                <FaMobileAlt
                  color="white"
                  size={20}
                  style={{marginRight: 10}}
                />
                <input
                  type="text"
                  maxLength={10}
                  placeholder="Mobile Number"
                  className="custominput"
                  value={mobile}
                  onChange={e => setMobile(e.target.value)}
                  style={styles.input}
                />
              </div>

              {/* Password */}
              <div style={{position: 'relative', marginTop: 10}}>
                <div style={styles.inputWrapper}>
                  <FaKey color="white" size={20} style={{marginRight: 10}} />
                  <input
                    type={passwordShow ? 'password' : 'text'}
                    placeholder="Password"
                    className="custominput"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    style={styles.input}
                  />
                </div>
                <button
                  onClick={() => navigate('/forgot')}
                  style={styles.forgotBtn}>
                  Forgot?
                </button>
              </div>

              {/* Login Button */}
              <button onClick={login} style={styles.loginBtn}>
                <span
                  style={{color: 'white', fontWeight: 'bold', fontSize: 18}}>
                  Login
                </span>
              </button>

              {/* Register Section */}
              <div style={styles.registerWrapper}>
                <span
                  style={{fontWeight: 'bold', color: 'white', marginRight: 10}}>
                  New to the app?
                </span>
                <button
                  onClick={() => navigate('/signup')}
                  style={styles.registerBtn}>
                  Register
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PostFree;

const styles = {
  bg: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  layer: {
    width: '100%',
    maxWidth: 400,
    margin: '0 auto',
    padding: 15,
    textAlign: 'center',
  },
  card: {
    backgroundColor: 'rgba(0,0,0,0.4)',
    borderRadius: 20,
    padding: 20,
    border: '1px solid #10C2AA',
  },
  inputWrapper: {
    display: 'flex',
    alignItems: 'center',
    border: '2px solid #10C2AA',
    borderRadius: 10,
    backgroundColor: 'rgba(255,255,255,0.1)',
    padding: '10px 12px',
    marginBottom: 10,
  },
  input: {
    flex: 1,
    backgroundColor: 'transparent',
    border: 'none',
    color: 'white',
    outline: 'none',
  },
  forgotBtn: {
    position: 'absolute',
    right: 0,
    top: 14,
    background: 'none',
    border: 'none',
    color: '#fff',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  loginBtn: {
    width: '100%',
    borderRadius: 12,
    marginTop: 25,
    padding: '14px 0',
    backgroundColor: '#0AB4A7',
    border: 'none',
    cursor: 'pointer',
  },
  registerWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 20,
  },
  registerBtn: {
    background: 'none',
    border: 'none',
    color: 'white',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
};
